exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".landing-wrapper-main .footer{background:#f7f9fb}.landing-wrapper-main .footer .header h1{font-size:22px;line-height:26px;color:#000;margin-left:20px}.landing-wrapper-main .footer .links{display:flex;justify-content:center;margin:50px 0}.landing-wrapper-main .footer .copyright,.landing-wrapper-main .footer .social{display:flex;justify-content:center}@media (max-width:767px){.landing-wrapper-main .footer .header{margin-top:25px}.landing-wrapper-main .footer .header .company-logo p{max-width:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./directives/footer/footer.scss
// module id = 254
// module chunks = 0